import React, { useState, useEffect } from 'react'
import { ObjViewer } from 'react-obj-viewer'
import PropTypes from 'prop-types'

function ThreeDSlideComponent(props) {
  const { mcData, timerEnd, onValueChange } = props
  const [width3d, setWidth3D] = useState(200)
  const [height3d, setHeight3D] = useState(200)
  const [render3D, setRender3D] = useState(true)

  const { ObjectUrl, TextureUrl, ControlID } = mcData

  function render3DModel() {
    let ThreeParent, Width3D, Height3D
    ThreeParent = document.getElementById('3d-parent')
    if (ThreeParent !== null) {
      Width3D = ThreeParent.offsetWidth
      Height3D = ThreeParent.offsetHeight
      if (Width3D != width3d || Height3D != height3d) {
        setWidth3D(ThreeParent.offsetWidth)
        setHeight3D(ThreeParent.offsetHeight)
        setRender3D(!render3D)
      }
      return (
        <ObjViewer
          model={ObjectUrl}
          material={TextureUrl}
          width={width3d}
          height={height3d}
        />
      )
    }
  }

  useEffect(() => {
    if (timerEnd) {
      onValueChange(ControlID, '', 0, 0, '', true)
    }
  }, [timerEnd])

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: 'lightblue',
        justifyContent: 'center',
        borderRadius: '10px',
        padding: '15px'
      }}
    >
      <div
        id='3d-parent'
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            flex: 1,
            width: '50%',
            height: '50%',
            display: 'flex',
            flexDirection: 'column',
            borderColor: 'black',
            borderWidth: '1px',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '30%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {render3D && render3DModel()}
            {!render3D && render3DModel()}
          </div>
        </div>
      </div>
    </div>
  )
}

ThreeDSlideComponent.propTypes = {
  mcData: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  timerEnd: PropTypes.bool
}

export default ThreeDSlideComponent
